import request from '@/utils/request';
import Resource from '@/api/resource';

class UpgradePlanResource extends Resource {
  constructor() {
    super('plan/jrttUpgrade');
  }

  // 升级版智能批量新建计划
  upgradeBatchCreatPlanApi(data) {
    return request({
      url: `/${this.uri}/aiBatch`,
      method: 'POST',
      data,
    });
  }
}

export { UpgradePlanResource as default };
